import { render, staticRenderFns } from "./research.vue?vue&type=template&id=1633e08c&scoped=true"
import script from "./research.ts?vue&type=script&lang=ts&external"
export * from "./research.ts?vue&type=script&lang=ts&external"
import style0 from "./research.scss?vue&type=style&index=0&id=1633e08c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1633e08c",
  null
  
)

export default component.exports